import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import clsx from 'clsx';
import { orderBy } from 'lodash';

import {
    ListBox,
    ListBoxToolbar,
    processListBoxData,
    processListBoxDragAndDrop,
} from '@progress/kendo-react-listbox';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';

import ConfigurationItem from './ConfigurationItem';

import * as AttributeManagementActions from '../../../actions/attributeManagementActions';

import * as classes from './ValueConfigurationListBox.module.css';

const SELECTED_FIELD = 'selected';

const ValueConfigurationListBox = ({
    activeNavCompany,
    attributeValues,
    createAttributeValue,
    facets,
    fetchAttributeValues,
    items,
    setItems,
    selectedAttribute,
    selectedEntity,
    ...props
}) => {
    useEffect(() => {
        let values = [...attributeValues];
        values.map(item => item.available === false);
   
        values.forEach((item, index) => {
            if (!values.find(value => value.id === item.id && value.companyId !== item.companyId)) {
                if (item.companyAVPFacets.find(facet => facet.facetName === 'selected' && facet.value === '1')) {
                    item.selected = false;
                    item.available = false;
                } else {
                    item.selected = false;
                    item.available = true;
                }
            } else {
                if (item.companyId !== '00000000-0000-0000-0000-000000000000') {
                    if (item.companyAVPFacets.find(facet => facet.facetName === 'selected' && facet.value === '1')) {
                        item.selected = false;
                        item.available = false;
                    } else {
                        item.selected = false;
                        item.available = true;
                    }
                } else {
                    item.selected = false;
                    item.available = true;
                    item.remove = true;
                }
            }
        });

        values = values.filter(item => item.remove !== true);

        values.unshift({ name: 'Select All', id: 'select', available: true, selected: false });
        values.unshift({ name: 'Select All', id: 'select', available: false, selected: false });
        setItems(values);
    }, [attributeValues]);

    const [state, setState] = useState({
        available:   items.filter((item) => item.available),
        unavailable: items.filter((item) => !item.available),
        draggedItem: {},
    });

    useEffect(() => {

        const available = items.filter((item) => item.available);
        const unavailable = items.filter((item) => !item.available);

        setState({ ...state, available, unavailable });
    }, [items]);

    const [availableSearch, setAvailableSearch] = useState('');
    const [selectedSearch, setSelectedSearch] = useState('');
    const [sortState, setSortState] = useState('asc');

    const handleDragStart = (e) => {
        if (e.dataItem.id === 'select') return;
        setState({ ...state, draggedItem: e.dataItem });
    };

    const handleDrop = (e) => {
        if (e.dataItem.id === 'select') return;
        let result = processListBoxDragAndDrop(
            state.unavailable,
            state.available,
            state.draggedItem,
            e.dataItem,
            'id'
        );

        setState({
            ...state,
            unavailable: result.listBoxOneData,
            available:   result.listBoxTwoData,
        });
    };

    const handleToolBarClick = (e) => {
        let toolName = e.toolName || '';
        let result = processListBoxData(
            state.available.filter(item => item.id !== 'select'),
            state.unavailable.filter(item => item.id !== 'select'),
            toolName,
            SELECTED_FIELD
        );

        let availableResult = result.listBoxOneData;
        availableResult.unshift({ name: 'Select All', id: 'select', available: true, selected: false });

        let unavailableResult = result.listBoxTwoData;
        unavailableResult.unshift({ name: 'Select All', id: 'select', available: true, selected: false });

        availableResult.map(item => item.available = true);
        unavailableResult.map(item => item.available = false);

        const merged = [...availableResult, ...unavailableResult];

        setItems(merged);

        setState({
            ...state,
            available:   availableResult,
            unavailable: unavailableResult,
        });
    };

    const handleItemClick = (event, data, connectedData) => {
        if (event.dataItem.id === 'input') return;

        const newData = [...state[data]];

        if (event.dataItem.id === 'select') {
            if (event.dataItem.selected) {
                let searchString = data === 'available' ? availableSearch : selectedSearch;

                if (searchString) {
                    state[data].filter(item => item.id === 'select' || item.name.toLowerCase().includes(searchString.toLowerCase())).forEach(item => {
                        item[SELECTED_FIELD] = false;
                    });
                } else {
                    newData.forEach(item => {
                        item[SELECTED_FIELD] = false;
                    });
                }
            } else {
                let searchString = data === 'available' ? availableSearch : selectedSearch;

                if (searchString) {
                    state[data].filter(item => item.id === 'select' || item.name.toLowerCase().includes(searchString.toLowerCase())).forEach(item => {
                        item[SELECTED_FIELD] = true;
                    });
                } else {
                    newData.forEach(item => {
                        item[SELECTED_FIELD] = true;
                    });
                }
            }
        } else {
            const current = newData.findIndex(
                (dataItem) => dataItem === event.dataItem
            );

            if (newData[current][SELECTED_FIELD]) {
                newData[current][SELECTED_FIELD] = false;
            } else {
                newData[current][SELECTED_FIELD] = true;
            }
        }

        setState({
            ...state,
            [data]:          newData,
            [connectedData]: state[connectedData].map((item) => {
                item[SELECTED_FIELD] = false;
                return item;
            }),
        });
    };

    const handleAddItem = () => {
        if (!state.available.find(item => item.id === 'input')) {
            let updatedState = { ...state };
            updatedState.available.push({ name: '', id: 'input', available: true, selected: false });
            setState(updatedState);
        }
    };

    const handleSort = () => {
        const updatedState = { ...state };

        if (sortState === 'asc') {
            setSortState('desc');

            updatedState.unavailable = orderBy(state.unavailable.filter(item => item.id !== 'select'), ['name'], ['desc']);
            updatedState.unavailable.unshift({ name: 'Select All', id: 'select', available: false, selected: false });
            setState(updatedState);
        } else {
            setSortState('asc');

            updatedState.unavailable = orderBy(state.unavailable.filter(item => item.id !== 'select'), ['name'], ['asc']);
            updatedState.unavailable.unshift({ name: 'Select All', id: 'select', available: false, selected: false });
            setState(updatedState);
        }
    };

    const onCancel = () => {
        const updatedState = { ...state };
        updatedState.available = updatedState.available.filter(item => item.id !== 'input');
        setState(updatedState);
    };

    const onSave = async text => {
        const updatedState = { ...state };

        updatedState.available = updatedState.available.filter(item => item.id !== 'input');

        setState(updatedState);

        const body = {
            companyAVPs: [{
                avp: {
                    value: text
                },
                entityId: selectedEntity.id,
            }]
        };

        await createAttributeValue(activeNavCompany.id, selectedAttribute.id, body);
        await fetchAttributeValues(activeNavCompany.id, selectedAttribute.id);
    };

    const TestConfigurationItem = props => {
        let { dataItem, selected, ...others } = props;
        const [text, setText] = useState('');

        if (selected && dataItem.id !== 'input') {
            others['className'] = clsx(others['className'], classes.Selected);
        } else if (dataItem.id === 'input') {
            others['className'] = clsx(others['classname'], classes.Input);
        }

        return (
            <li {...others}>
                <div>
                    {
                        dataItem.id === 'input' ?
                            <FormControl className={classes.InputWrapper} variant="outlined" size="small">
                                <TextField
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}
                                    className={classes.Textfield}
                                    id="outlined-basic"
                                    label="Enter"
                                    size="small"
                                    variant="outlined"
                                />
                                <span role="none" onClick={() => onSave(text)} className={clsx('material-icons-outlined', classes.Icon)}>
                                    done
                                </span>
                                <span role="none" onClick={() => onCancel()} className={clsx('material-icons-outlined', classes.Icon)}>
                                    close
                                </span>
                            </FormControl>
                            :
                            <React.Fragment>
                                <Checkbox
                                    value="include"
                                    checked={selected}
                                    name="include"
                                    style={{
                                        transform: 'scale(1.5)',
                                        color:     'black'
                                    }}
                                />
                                <span className={classes.Text}>
                                    {props.dataItem.name}
                                </span>
                            </React.Fragment>
                    }
                </div>
            </li>
        );
    };

    return (
        <div className={classes.ListBox}>
            <div className={classes.ListContainer}>
                <div>
                    Available
                    <div className={classes.SearchContainer}>
                        <span className={clsx('material-icons-outlined md-18', classes.SearchBar)}>
                            search
                        </span>
                        <TextField
                            value={availableSearch}
                            onChange={(e) => setAvailableSearch(e.target.value)}
                            className={classes.margin}
                            id="input-with-icon-textfield"
                            placeholder="Search by keyword"
                            InputProps={{
                                style:            { fontSize: '1.2rem' },
                                disableUnderline: true
                            }}
                            InputLabelProps={{
                                style: { color: '#c6c6c6' },
                            }}
                        />
                    </div>
                </div>
                <div>
                    <ListBox
                        style={{
                            height:    '55vh',
                            width:     '50rem',
                            minHeight: '25.8rem',
                            maxHeight: '66rem',
                        }}
                        item={state.available.find(item => item.id === 'input') ? TestConfigurationItem : ConfigurationItem}
                        selectedField={SELECTED_FIELD}
                        data={availableSearch ? state.available.filter(item => item.id === 'select' || item.name.toLowerCase().includes(availableSearch.toLowerCase())) : state.available}
                        textField="name"
                        onItemClick={(e) =>
                            handleItemClick(e, 'available', 'unavailable')
                        }
                        onDragStart={handleDragStart}
                        onDrop={handleDrop}
                        toolbar={() => {
                            return (
                                <ListBoxToolbar
                                    tools={[
                                        'moveUp',
                                        'moveDown',
                                        'transferTo',
                                        'transferFrom',
                                        'transferAllTo',
                                        'transferAllFrom'
                                    ]}
                                    data={state.available}
                                    dataConnected={state.unavailable}
                                    selectedField={SELECTED_FIELD}
                                    onToolClick={handleToolBarClick}
                                />
                            );
                        }}
                    />
                </div>
                <div className={classes.AddContainer}>
                    <div role="none" onClick={() => handleAddItem() } className={classes.AddContainerButton}>
                        <span className={clsx('material-icons-outlined', classes.AddButton)}>
                            add
                        </span>
                        <div className={classes.AddText}>Add Attribute Value</div>
                    </div>
                </div>
            </div>
            <div className={classes.ListContainer}>
                <div style={{ paddingLeft: '1.3rem' }}>
                    Selected
                    <div className={classes.SelectedSearchContainer}>
                        <span className={clsx('material-icons-outlined md-18', classes.SearchBar)}>
                            search
                        </span>
                        <TextField
                            value={selectedSearch}
                            onChange={(e) => setSelectedSearch(e.target.value)}
                            className={classes.margin}
                            id="input-with-icon-textfield"
                            placeholder="Search by keyword"
                            InputProps={{
                                disableUnderline: true
                            }}
                        />
                    </div>
                </div>
                <div className={classes.SortContainer}>
                    <div role="none" onClick={() => handleSort()} className={classes.SortContainerButton}>
                        <div className={classes.AddText}>Sort</div>
                        {
                            sortState === 'asc' ?
                                <span className={clsx('material-icons-outlined', classes.AddButton)}>
                                    expand_more
                                </span>
                                :
                                <span className={clsx('material-icons-outlined', classes.AddButton)}>
                                    expand_less
                                </span>
                        }
                    </div>
                </div>
                <ListBox
                    style={{
                        height:      '55vh',
                        width:       '45.2rem',
                        minHeight:   '25.8rem',
                        maxHeight:   '66rem',
                        paddingLeft: '12px',
                    }}
                    onItemClick={(e) =>
                        handleItemClick(e, 'unavailable', 'available')
                    }
                    item={ConfigurationItem}
                    data={selectedSearch ? state.unavailable.filter(item => item.id === 'select' || item.name.toLowerCase().includes(selectedSearch.toLowerCase())) : state.unavailable}
                    selectedField={SELECTED_FIELD}
                    textField="name"
                    onDragStart={handleDragStart}
                    onDrop={handleDrop}
                />
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        attributeValues:  state.attributeManagement.attributeValues,
        facets:           state.attributeManagement.facets
    };
};

const mapDispatchToProps = {
    ...AttributeManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ValueConfigurationListBox);
